import angular from 'angular';
import uirouter from 'angular-ui-router';
import routing from './routes';

import ProfileController from './ProfileController';
import angularFileUpload from 'angular-file-upload';
import profileVisitor from '../../directives/profileVisitor';
import profileHome from '../../directives/profileHome';
import profileEdit from '../../directives/profileEdit';
import profileEditMatch from '../../directives/profileEditMatch';
import photoGallery from '../../directives/photoGallery';
import matchesMessage from '../../directives/matchesMessage';
import flagUser from '../../directives/flagUser';
import blockUser from '../../directives/blockUser';
import 'ng-img-crop/compile/minified/ng-img-crop.js';
import 'ng-img-crop/compile/minified/ng-img-crop.css';

import panel from '../../services';

export default angular.module('app.pc', [
        uirouter,
        panel,
        'angularFileUpload',
        profileVisitor,
        profileHome,
        profileEdit,
        profileEditMatch,
        photoGallery,
        matchesMessage,
        flagUser,
        blockUser,
        'ngImgCrop'
    ])
    .config(routing)
    .controller('ProfileController', ProfileController)
    .name;



// WEBPACK FOOTER //
// ./src/app/features/profile/index.js